<div class="tip-dialog dialog-container mb-6" *ngIf="data.content">
    <div class="tip-dialog-title-wrapper">
        <h2 mat-dialog-title>{{ data.title }}</h2>
        
        <button mat-icon-button class="close-button" [matDialogClose]="true">
            <mat-icon [svgIcon]="SvgIcon.Close"></mat-icon>
            <span class="sr-only">{{ 'tip.dialog.close' | translate }}</span>
        </button>
    </div>
    <div mat-dialog-content [innerHtml]="data.content" cdkScrollable>
    </div>
    <hr *ngIf="data.link">
    <div class="e-learning" *ngIf="data.link">
        <h3 class="h4 mt-0 mb-0">{{ 'tip.dialog.e_learning.heading' | translate }}</h3>
    </div>
    <p *ngIf="data.link && data.linkText"> {{ 'tip.dialog.e_learning.pre_link_text' | translate }}
        <a [href]="data.link" target="_blank" rel="noreferrer">{{ data.linkText | translate }}</a>
        {{ 'tip.dialog.e_learning.post_link_text' | translate }}
    </p>
</div>
